import { cn } from '../../lib/utils';
import './ui.css';

export function TableContainer({ className, ...props }) {
  return <div className={cn('ui-table-wrap', className)} {...props} />;
}

export function Table({ className, ...props }) {
  return <table className={cn('ui-table', className)} {...props} />;
}

export function TableHead({ className, ...props }) {
  return <th className={className} {...props} />;
}

export function TableRow({ className, ...props }) {
  return <tr className={className} {...props} />;
}

export function TableBody({ className, ...props }) {
  return <tbody className={className} {...props} />;
}

export function TableHeader({ className, ...props }) {
  return <thead className={className} {...props} />;
}

export function TableCell({ className, ...props }) {
  return <td className={className} {...props} />;
}
